import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, MessageService } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { QUICKLINK_ACTION_TYPE, QuicklinkAction } from "./quicklink.action";
import { quicklinkMessageContext } from "./quicklink.const";
import { QuicklinkService } from "./quicklink.service";

/**
 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
 */
@Injectable()
export class QuicklinkEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	get$ = createEffect(() =>
		this.actions$.pipe(
			ofType(QUICKLINK_ACTION_TYPE.get),
			switchMap(() =>
				this.service.get().pipe(
					map((response) => this.action.getSuccess(response)),
					catchError((error: AppError) => of(this.action.getFail(error)))
				)
			)
		)
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[QUICKLINK_ACTION_TYPE.getFail]: quicklinkMessageContext.get,
			}),
			this.messageService.mapClearByContext$({
				[QUICKLINK_ACTION_TYPE.get]: quicklinkMessageContext.get,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: QuicklinkAction,
		private service: QuicklinkService,
		private messageService: MessageService
	) {}
}
